import type { FC } from "react";

import { Box } from "@jti/core-components/components/Box";
import { Swatch } from "@jti/core-components/components/Swatch";
import { type ConfigurableProduct, type StockStatusElements } from "@jti/fe-common";

import { getOptionsForSwatch } from "@product-details/utils/getOptionsForSwatch";

import styles from "./ProductConfigurableBlock.module.scss";

type ProductConfigurableBlockProps = {
  label: string;
  options: ConfigurableProduct[];
  value: string;
  stock?: StockStatusElements;
};

const getCurrentOption = (options: ConfigurableProduct[], value: string): ConfigurableProduct | undefined =>
  options.find(({ id }) => id === value);

export const ProductConfigurableBlock: FC<ProductConfigurableBlockProps> = ({ label, options = [], value, stock }) => {
  if (options.length === 0) {
    return null;
  }

  const option = getCurrentOption(options, value);

  return (
    <Box title={label}>
      <Swatch
        aria-label={label}
        items={getOptionsForSwatch(options, false, stock).map(({ color, label, value, isDisabled }) => ({
          color,
          label,
          value,
          isOutOfStock: isDisabled,
        }))}
        value={value}
        onChange={(item) => {
          const selectedOption = options.find(({ label }) => label === item.label);

          if (selectedOption) {
            window.location.href = selectedOption.url;
          }
        }}
      />
      {!!option && <span className={styles.optionLabel}>{option?.label}</span>}
    </Box>
  );
};
